export enum CameraTypeEnum {
  USER = 'USER',
  ENVIRONMENT = 'ENVIRONMENT',
}
